import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlogCalendar from '../components/BlogCalendar';

const Blog = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'TiLimousine Blog',
    description: 'Expert insights on premium transportation, corporate travel, and luxury chauffeur services.',
    url: 'https://tilimousine.com/blog',
    publisher: {
      '@type': 'Organization',
      name: 'TiLimousine',
      logo: {
        '@type': 'ImageObject',
        url: 'https://tilimousine.com/logo.png'
      }
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Blog | TiLimousine - Premium Transportation Insights</title>
        <meta 
          name="description" 
          content="Expert insights on premium transportation, corporate travel, and luxury chauffeur services. Stay informed about the latest trends in executive transportation."
        />
        <link rel="canonical" href="https://tilimousine.com/blog" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <Navbar />

      <main className="container mx-auto px-4 py-16">
        <header className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-cinzel text-gold mb-6">
            TiLimousine Blog
          </h1>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Expert insights on premium transportation, corporate travel, and luxury chauffeur services.
            Stay informed about the latest trends in executive transportation.
          </p>
        </header>

        <BlogCalendar />
      </main>

      <Footer />
    </div>
  );
};

export default Blog; 